// extracted by mini-css-extract-plugin
export default {"warning":"ProductBadges_warning__Q3Jzv"};